<script lang="ts" setup>
import { computed } from 'vue';
import type { VAvatar } from 'vuetify/components';
import type { IInitialsAvatarProps } from '@/types/components/general/InitialsAvatar';

const props = defineProps<IInitialsAvatarProps>();

const initials = computed(() => {
  if (props.name) {
    // Remove all special characters except spaces, then split
    const cleanName = props.name.replace(/[^a-zA-Z0-9 ]/g, '').trim();
    const initials = cleanName.split(' ').map((word) => word.charAt(0));
    const firstInitial = initials.shift();
    const lastInitial = initials.pop();
    return `${firstInitial ?? ''}${lastInitial ?? ''}`.toUpperCase();
  }
  return '';
});
</script>

<template>
  <v-avatar
    :class="['avatar', { 'avatar--selected': props.isSelected, 'avatar--bimi': props.image }]"
    :color="props.color ?? undefined"
    :size="props.size ?? 48"
    variant="outlined"
  >
    <v-icon v-if="props.isSelected" data-test-id="avatar-selected-icon" large>mdi-check</v-icon>
    <v-icon v-else-if="props.icon" data-test-id="avatar-custom-icon" large>{{ props.icon }}</v-icon>
    <img v-else-if="props.image" :alt="initials" :src="props.image" data-test-id="avatar-image" />
    <span v-else-if="initials" data-test-id="avatar-initials">
      {{ initials }}
    </span>
    <v-icon v-else data-test-id="avatar-icon" large>mdi-account-outline</v-icon>
  </v-avatar>
</template>

<style lang="scss" scoped>
.avatar {
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  background: rgb(var(--v-theme-on-primary));
  color: rgb(var(--v-theme-primary));

  &--selected {
    background: rgb(var(--v-theme-primary)) !important;
    color: rgb(var(--v-theme-on-primary));
  }

  &--bimi {
    background: white;
  }
}
</style>
